module.exports = __webpack_public_path__ + "media/images/es_419/methods_continuum-c54e515fbfe09d82536c86c7accbd579.png";